import $ from 'jquery';

const helloEmail = 'hello@bravabod.com';
const infoEmail = 'info@bravabod.com';

function mailTo(email) {
    return `<a href='mailto:${email}'>${email}</a>`;
}

const CONTACT_REASON_COPY = {
    question: [
        `Awesome! 
        The best way to get in touch is to write ${mailTo(helloEmail)}.
        We read every message and do our best to respond within 48 business hours.`,

        `When it comes to customer care, we're a little obsessive.
        So if you don't hear back from us, that means we didn't get your note so please do send it again.`,
    ],
    contributor: [
        `We're looking to create a better home for nutritionists, entrepreneurs, busy professionals, and athletes alike. 
        Being a contributor connects you to new faces, so you can focus on sharing your unique recipes & meal plans while promoting your skills.`,

        `In our upcoming Bod Partner Program, contributors are paid based on how deeply readers engage with their meals, not based on clicks or social media followers. 
        Every month, we'll divide each member's subscription fee in proportion to the meals he/she engaged with that month. 
        That means the quality of your meals directly correlates to the income you can earn. Saaweet!`,

        `There's more details, and we're sure you have questions too - so if you're interested, please email us at ${mailTo(infoEmail)} with some more information about yourself. 
        Can't wait to e-meet you!`,
    ],
    issue: [
        `Oops, did we mess up? Let us know if something's not working at ${mailTo(infoEmail)}. 
        Tech can be finicky, so please be patient with us while we fix the issue as quickly as possible for you.`,
    ],
    cancel: [
        `We want you to find what works best for your bod, even if it's not with us. 
        Please reach out to ${mailTo(infoEmail)} so we can help.`,
    ],
};

function copyMarkup(choice) {
    let copy = CONTACT_REASON_COPY[choice];
    if (copy) {
        return copy.map(function (paragraph) {
           return `<p>${paragraph}</p>`;
        });
    } else {
        return '';
    }
}

export default class {
    constructor() {
        this.init();
    }

    init() {
        $('#contact-reason').change(function (e) {
            $('.contact-instructions').html(copyMarkup(e.target.value));
        });
    }
}


// WEBPACK FOOTER //
// ./scripts/modules/Contact.js